module.exports = __webpack_public_path__ + "img/1.b2ae5db8.jpg";